import { BASE_PATH_API } from '@root/manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';
import { CreateTaskWorkSessionDTO } from '@root/app/tasks/data/dtos/create-task-work-session.dto';
import { UpdateWorkSessionDTO } from '@root/app/tasks/data/dtos/update-work-session.dto';
import { StopWorkSessionDTO } from '@root/app/tasks/data/dtos/stop-work-session.dto';
import { WorkSessionDTO } from '@root/src/app/features/work-sessions/dtos/work-session.dto';
import { IHttpParamSerializer } from 'angular';
import { WorkSessionBulkUpdateDTO } from '@root/app/tasks/data/dtos/work-session-bulk-update.dto';

const actions = {
    createTaskWorkSession: {
        method: 'POST',
        url: `${BASE_PATH_API}/taskWorkSessions`
    },
    createWorkOrderWorkSession: {
        method: 'POST',
        url: `${BASE_PATH_API}/workOrderWorkSessions`
    },
    getActiveWorkSession: {
        method: 'GET',
        url: `${BASE_PATH_API}/worksessions/self`
    },
    stopWorkSession: {
        method: 'PUT',
        url: `${BASE_PATH_API}/worksessions/self`
    },
    getWorkSessions: {
        method: 'GET',
        url: `${BASE_PATH_API}/worksessions`
    },
    deleteWorkSessionById: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/worksessions/:id`
    },
    updateWorkSession: {
        method: 'PUT',
        url: `${BASE_PATH_API}/worksessions/:id`
    },
    bulkUpdateWorkSession: {
        method: 'PUT',
        url: `${BASE_PATH_API}/worksessions/bulk`
    }

};

export interface IWorkSessionsApi {
    createTaskWorkSession(createWorkSession: CreateTaskWorkSessionDTO): Promise<WorkSessionDTO>;
    createWorkOrderWorkSession(createWorkSession: CreateTaskWorkSessionDTO): Promise<WorkSessionDTO>;
    stopWorkSession(stopWorkSession: StopWorkSessionDTO): Promise<WorkSessionDTO>;
    getActiveWorkSession(): Promise<WorkSessionDTO>;
    getWorkSessions(params: { TaskId: number, WorkOrderIds: number[] }): Promise<WorkSessionDTO[]>;
    deleteWorkSessionById(params: { id: number }): Promise<void>;
    updateWorkSession(params: { id: number }, updateWorkSession: UpdateWorkSessionDTO): Promise<WorkSessionDTO>;
    bulkUpdateWorkSession(workSessionBulkUpdateDTO: WorkSessionBulkUpdateDTO): Promise<void>;
    getWorkSessionsExportUrl(params: any): string;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function WorkSessionsApi($httpParamSerializer: IHttpParamSerializer): IWorkSessionsApi {
    const service = createActions(actions);
    service.getWorkSessionsExportUrl = (params: object) => {
        return `${BASE_PATH_API}/workSessions/export?${$httpParamSerializer(params)}`;
    };
    return service;
}

WorkSessionsApi.$inject = [
    '$httpParamSerializer'
];
